<template>
  <div class="service-cert app-container">
    <div v-if="showAuditPage" class="card flex-1">
      <div class="guide-header">精彩纵横云采购平台适用引导</div>
      <div class="guide-header-tip">
        为了您可以尽快参与或发布采购项目，请按照下方引导流程进行操作
      </div>

      <!--服务选择卡片-->
      <div class="service-card-wrapper flex row-center">
        <div
          v-for="service in usablePlatformServiceList"
          :key="service.alias"
          class="service-card flex flex-col"
          :class="{ active: currentService === service.value }"
          @click="currentService = service.value"
        >
          <div
            class="selected-tag flex row-center col-center"
            :class="{ active: currentService === service.value }"
          >
            <el-icon class="el-icon-check" />
          </div>

          <img
            :src="require(`@/assets/images/service/${service.alias}-icon.png`)"
            alt=""
          />
          <div class="service-card-label">{{ service.label }}</div>
          <div class="service-card-desc m-t-12">{{ service.desc }}</div>
        </div>
      </div>

      <!--确定按钮-->
      <div class="m-t-48 flex row-center">
        <el-button
          type="primary"
          class="cert-btn"
          :disabled="!currentService"
          @click="submitServiceCert"
        >提交身份认证</el-button>
      </div>
    </div>

    <!--展示服务审核流程页面-->
    <service-cert-status
      v-else
      :show-back-btn="false"
      @reSelect="reSelectService = true"
    />
  </div>
</template>

<script>
// 组件
import ServiceCertStatus from '@/components/common/Company/ServiceCertStatus'

// 工具函数
import { mapState } from 'vuex'

// 数据字典
import { workbenchServiceDict } from '@/dictionary/system'

// api接口
import { applyServiceApi, getCompanyAllAuditStatusApi } from '@/api/company'

export default {
  name: 'ServiceCert',

  components: { ServiceCertStatus },

  props: {
    serviceType: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 当前选中的身份
      currentService: '',
      hasAuditService: false,
      reSelectService: false
    }
  },

  computed: {
    ...mapState('company', ['companyType']),

    // 当前企业可以开通的身份列表
    usablePlatformServiceList() {
      return workbenchServiceDict.array.filter(value => {
        return (
          value.companyType.findIndex(obj => obj.value === this.companyType) >
          -1
        )
      })
    },

    showAuditPage() {
      return !this.hasAuditService || this.reSelectService
    }
  },

  created() {
    this.getCompanyAllAuditStatus()
  },

  methods: {
    /**
     * 获取服务开通状态
     */
    getCompanyAllAuditStatus() {
      getCompanyAllAuditStatusApi()
        .then(res => {
          const data = res?.data || {}
          this.hasAuditService = Object.keys(data).length > 1
        })
        .catch(err => {
          this.$message.error(err?.message)
        })
    },

    /**
     * 提交身份开通
     */
    submitServiceCert() {
      const label =
        workbenchServiceDict.translate(this.currentService)?.label || ''

      this.$systemConfirm(`是否申请开通${label}身份`).then(result => {
        if (!result) return

        applyServiceApi({ serviceType: this.currentService })
          .then(res => {
            this.reSelectService = false
            this.getCompanyAllAuditStatus()
          })
          .catch(err => {
            this.$message.error(err?.message || '身份开通失败')
          })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.service-cert {
  width: 1200px;
  margin: 0 auto;

  .guide-header {
    margin-top: 32px;
    font-size: 20px;
    @include text-bold;
    text-align: center;
  }

  .guide-header-tip {
    margin-top: 8px;
    text-align: center;
    color: $second-text-color;
  }

  //服务卡片样式
  .service-card-wrapper {
    margin-top: 48px;

    .service-card {
      position: relative;
      width: 260px;
      height: 320px;
      border: 1px solid $info-third-color;
      border-radius: 4px;
      transition: transform 0.3s ease-in-out;
      margin: 0 8px;

      &:hover,
      &.active {
        border-color: $primary-color;
        transform: translateY(-12px);
      }

      img {
        width: 140px;
        height: auto;
        margin-top: 60px;
      }

      .selected-tag {
        position: absolute;
        top: 18px;
        right: 24px;
        width: 22px;
        height: 22px;
        border: 1px solid $info-third-color;
        color: transparent;
        border-radius: 50%;

        &.active {
          border-color: $primary-color;
          background-color: $primary-color;
          color: $white-color;
        }
      }

      .service-card-label {
        margin-top: 40px;
        @include text-bold;
      }
      .service-card-desc {
        font-size: 12px;
        color: $third-text-color;
      }
    }
  }

  // 认证按钮
  .cert-btn {
    width: 160px;
  }
}
</style>
